import { mostRecentParallelJobs } from "~/components/build/Show/lib/BuildContext";
import { sortByState } from "~/components/build/Show/components/TableView/TableCell";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import { JobPillLink } from "~/components/build/Show/components/StepDrawer/JobPillLink";
import { CommandJob } from "~/components/build/Show/lib/types";
import { useStepDrawer } from "~/components/build/Show/components/StepDrawer/StepDrawerContext";
import {
  AnnotationsBadge,
  totalAnnotationCount,
} from "~/components/build/Show/components/Sidebar/TreeNode/AnnotationsBadge";

export const ParallelStepJobs = () => {
  const { jobs } = useStepDrawer();
  const recentParallelJobs = mostRecentParallelJobs(jobs as CommandJob[]).sort(sortByState("asc"));

  return (
    <div className="flex h-full min-w-0 flex-auto flex-col gap-2 overflow-auto border-t border-gray-400 px-2.5 py-2">
      <div
        className="grid-col-dense grid gap-2.5"
        style={{
          // 75px is the minimum width that seems to handle 1000+ job counts
          gridTemplateColumns: "repeat(auto-fill, minmax(70px, 1fr))",
        }}
      >
        {recentParallelJobs.map((job) => {
          const index = job.parallelGroupIndex || 0;
          const jobAnnotations = job.statistics?.annotationCountsByStyle || {};
          const hasAnnotations = totalAnnotationCount(jobAnnotations) > 0;
          return (
            <JobPillLink
              job={job}
              key={job.id}
              className="relative text-inherit hover:text-inherit focus:text-inherit"
            >
              <span
                className={twMerge(
                  classNames(
                    "white small tabular-numerals text-charcoal-700 flex flex-1 justify-center rounded-sm border border-slate-500 bg-white px-1",
                    {
                      "border-lime-500": job.state === "finished" && job.passed,
                      "border-red-500": job.state === "finished" && !job.passed,
                      "border-orange-500": job.state === "running",
                    },
                  ),
                )}
              >
                {index + 1}
              </span>
              {hasAnnotations && (
                <AnnotationsBadge
                  countsByStyle={jobAnnotations}
                  className="absolute -right-2 -top-2"
                />
              )}
            </JobPillLink>
          );
        })}
      </div>
    </div>
  );
};
